import { create } from 'zustand';

let nextId = 1;

export const useNotifications = create((set, get) => ({
  items: [],
  unreadCount: 0,
  push: (n) => {
    const id = nextId++;
    const item = { id, time: Date.now(), read: false, ...n };
    set((s) => ({ items: [item, ...s.items].slice(0, 50), unreadCount: s.unreadCount + 1 }));
    return id;
  },
  markAllRead: () => set({ items: get().items.map((i) => ({ ...i, read: true })), unreadCount: 0 }),
  clear: () => set({ items: [], unreadCount: 0 })
}));
